"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _profile = require("@widget/profile");

var _options = require("@module/options");

var _utils = require("@package/utils");

var _app = require("@package/app");

var _settings = require("@preloader/settings");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Component = _interopRequireDefault(require("./Component"));

function HOC() {
  try {
    var getSelectedMerchant = function getSelectedMerchant() {
      return findMerchant(profile['merchant']['id']);
    };

    var findMerchant = function findMerchant(id) {
      return merchants.find(function (merchant) {
        return merchant['id'] === id;
      });
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var preloadingProcess = (0, _reactRedux.useSelector)(_options.selectPreloadingProcess);
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var merchants = (0, _reactRedux.useSelector)(_profile.selectAvailableMerchants);
    var isGetIdentificationData = profile['merchant']['type'] === 'INDIVIDUAL' && (0, _utils.checkPermission)(profile['user']['permissions'], 'merchant.identification.get');
    var activeMerchant = getSelectedMerchant();
    (0, _hoc.useMount)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.title = "".concat(process.env['REACT_APP_WEBSITE_NAME'], " - \u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B");
              dispatch((0, _options.setPreloadingProcess)(true));
              _context.next = 4;
              return dispatch((0, _options.getMerchantUsers)());

            case 4:
              _context.next = 6;
              return dispatch((0, _options.getOptionsData)());

            case 6:
              if (!isGetIdentificationData) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return dispatch((0, _options.getIdentificationData)(activeMerchant['id']));

            case 9:
              dispatch((0, _options.setPreloadingProcess)(false));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _options.resetStateAction)());
    });

    if (preloadingProcess) {
      return /*#__PURE__*/_react["default"].createElement(_settings.Preloader, null);
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Component["default"], null);
    }
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;